import * as types from '../actions/actionTypes';
import { loginResponse, lastCrosstabData } from './initialState';
import { LOGIN_TOKEN } from '../actions/urlTypes';

const initialState = { loginResponse, lastCrosstabData };

export default (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_SUCCESS: {
      // sessionStorage.removeItem('refreshCall');
      return {
        ...state,
        loginResponse: {
          ...loginResponse,
          data: {
            ...action.payload.data,
            uid: action.payload.data.userId,
            token: LOGIN_TOKEN,
          },
        },
      };
    }
    case types.MANAGE_USER_STATE_POPUP: {

      if (action.noLastSavedCrosstabFlag) {
        return {
          ...state,
          noLastSavedCrosstabFlag: true,
        };
      }
      return {
        ...state,
        lastCrosstabData: action.payload,
      };
    }
    case types.IS_USER_STATE_POPUP_SHOWN: {
      if (action.hasShown) {
        return {
          ...state,
          isUserStatePopupShown: {
            ...state.isUserStatePopupShown,
            [action.module]: action.hasShown,
          },
        };
      }
      return {
        ...state,
        isUserStatePopupShown: {},
      };
    }

    case types.IS_LOGOUT : {
      return{
        ...state,
        isLogout: action.isLogout
      }
    }
    default:
      return state;
  }
}
